import QRCode from 'react-qr-code';
import PropTypes from 'prop-types';
import addToAppleWallet from 'sealink/images/add-to-apple-wallet.svg';
import addToGoogleWallet from 'sealink/images/add-to-google-wallet.svg';

const PassCard = ({ pass }) => (
  <div className="card shadow-none">
    <div className="card-body d-flex align-items-center gap-3 py-2 px-3">
      {pass.reference && <QRCode value={pass.reference} size={80} />}
      <div className="flex-grow-1">
        {pass.consumer_type && (
          <div className="text-muted small">{pass.consumer_type}</div>
        )}
        {pass.consumer_name && (
          <div className="fw-bold">{pass.consumer_name}</div>
        )}
        <div className="d-flex flex-wrap align-items-center gap-2 mt-2">
          {pass.apple_wallet_url && (
            <a href={pass.apple_wallet_url} className="d-inline-block">
              <img
                src={addToAppleWallet}
                alt="Add to Apple Wallet"
                style={{ height: 40 }}
              />
            </a>
          )}
          {pass.google_wallet_url && (
            <a href={pass.google_wallet_url} className="d-inline-block">
              <img
                src={addToGoogleWallet}
                alt="Add to Google Wallet"
                style={{ height: 40 }}
              />
            </a>
          )}
        </div>
      </div>
    </div>
  </div>
);

export const passPropType = PropTypes.shape({
  uid: PropTypes.string.isRequired,
  reference: PropTypes.string,
  consumer_type: PropTypes.string,
  consumer_name: PropTypes.string,
  apple_wallet_url: PropTypes.string,
  google_wallet_url: PropTypes.string,
});

PassCard.propTypes = {
  pass: passPropType.isRequired,
};

export default PassCard;
